<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <input-text
            name="group"
            label="Group"
            v-model="form.group"
            class="mt-2"
            :error="errors.group ? errors.group[0] : null"
            :maxlength="255"
        />

        <input-text
            name="url"
            label="URL"
            v-model="form.url"
            class="mt-2"
            :error="errors.url ? errors.url[0] : null"
            :maxlength="255"
        />

        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Language</p>
            <reference
                create-text="Create new language and link language to this page"
                link-text="Link an existing language"
                v-model="form.site_language"
                model-data="Site Language"
                :creatable="false"
                :inline="true"
                :error="errors.site_language_id ? errors.site_language_id[0] : null"
                :order="{
                    'name': 'asc'
                }"
            />
        </div>

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";

export default {
    name: "HrefLangOverrideForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                group: this.getFormData("group"),
                url: this.getFormData("url"),
                site_language: this.getFormData("site_language"),
                site_language_id: this.getFormData("site_language_id"),
            },
        };
    },
    watch: {
        "form.site_language": function(newValue){
            this.form.site_language_id = newValue?.id || null
        },
    },
};
</script>
